export { ContactPage as default } from '@/components/enpages/Contact'
